// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-socials {
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-socials svg {
  width: auto;
  height: 35px;
  margin: 0.5rem 0;
}

.product-container .product-name {
  font-size: 2.5rem;
}

.product-container .product-category,
.product-container .select-bordered {
  font-size: 1.75rem;
}

.product-container .product-description {
  width: 90%;
}

.product-container .modal_form {
  display: flex;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/ProductDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".product-socials {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-socials svg {\n  width: auto;\n  height: 35px;\n  margin: 0.5rem 0;\n}\n\n.product-container .product-name {\n  font-size: 2.5rem;\n}\n\n.product-container .product-category,\n.product-container .select-bordered {\n  font-size: 1.75rem;\n}\n\n.product-container .product-description {\n  width: 90%;\n}\n\n.product-container .modal_form {\n  display: flex;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
